// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","top":"Header_top__ommZy","control":"Header_control__Q0qX+","logo":"Header_logo__shVBB"};